// removed by extract-text-webpack-plugin
module.exports = {"list-product":"list-product","product-wrap":"product-wrap","product":"product","price":"price"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/sub-view/list-product/style.scss
// module id = ./components/product-detail/sub-view/list-product/style.scss
// module chunks = 0